import React from 'react';
import PropTypes from 'prop-types';
import './Categories.css';

const Categories = ({ categories, selectedCategory, setSelectedCategory }) => {
  return (
    <section className="categories-container">
      <h2>Shop by Category</h2>
      <div className="categories-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category.id)}
            role="button"
            tabIndex={0}
            aria-label={`Select ${category.name} category`}
            onKeyPress={(e) => e.key === 'Enter' && setSelectedCategory(category.id)}
          >
            <img
              src={category.image || 'https://via.placeholder.com/150'}
              alt={category.name}
              className="category-image"
            />
            <h3>{category.name}</h3>
            <p>{category.description || `${category.productCount || 0} products`}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

Categories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string,
      description: PropTypes.string,
      productCount: PropTypes.number,
    })
  ).isRequired,
  selectedCategory: PropTypes.string,
  setSelectedCategory: PropTypes.func.isRequired,
};

Categories.defaultProps = {
  selectedCategory: null,
};

export default Categories;